import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { AuthShell, inputCls, labelCls } from "../components/AuthShell";

const ROLE_HOME = { admin: "/admin", sponsor: "/broker", borrower: "/borrower" };

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { resetPassword } = useAuth();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 6) return setErr("Password must be at least 6 characters.");
    if (pw !== pw2) return setErr("Passwords don't match.");
    setBusy(true);
    const r = await resetPassword(token, pw);
    setBusy(false);
    if (!r.ok) return setErr(r.error);
    toast.success("Password updated — you're signed in");
    nav(ROLE_HOME[r.user.role] || "/", { replace: true });
  };

  if (!token) {
    return (
      <AuthShell title="Reset password">
        <div className="rounded-md border border-rose-500/20 bg-rose-500/10 px-3 py-2 text-sm text-rose-300" data-testid="reset-password-missing-token">
          This reset link is missing its token. Please use the link from your email.
        </div>
        <Link to="/forgot-password" className="mt-6 block text-center text-sm text-emerald-300" data-testid="reset-request-new-link">Request a new link</Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Choose a new password" subtitle="Pick a password with at least 6 characters.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
        <div>
          <Label htmlFor="pw" className={labelCls}>New password</Label>
          <Input id="pw" type="password" required autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} className={inputCls} data-testid="reset-password-input" />
        </div>
        <div>
          <Label htmlFor="pw2" className={labelCls}>Confirm password</Label>
          <Input id="pw2" type="password" required autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} className={inputCls} data-testid="reset-password-confirm-input" />
        </div>
        {err && (
          <div className="rounded-md border border-rose-500/20 bg-rose-500/10 px-3 py-2 text-sm text-rose-300" data-testid="reset-password-error">
            {err}
            {err.includes("expired") && <Link to="/forgot-password" className="ml-1 underline" data-testid="reset-error-request-new-link">Request a new link</Link>}
          </div>
        )}
        <Button type="submit" disabled={busy} className="w-full bg-emerald-600 text-white hover:bg-emerald-500 disabled:opacity-60" data-testid="reset-password-submit-btn">
          {busy ? "Saving…" : "Save & sign in"}
        </Button>
      </form>
    </AuthShell>
  );
}
